export interface UserBanks {
    banks: BankDetails[];
    maximumAllowedUserBanks: number;
}
export interface BankDetails {
    id: number;
    iban?: string;
    accountHolderLegalName: string;
    bankName?: string;
    accountNumber?: string;
    branchName?: string;
    swiftCode?: string;
    branchAddress?: string;
    isComplete?: boolean;
    supportIban?: boolean;
    isDefault?: boolean;
}

export enum AddBankTemplates {
    IBAN = 'IBAN',
    MANUALLY = 'MANUALLY',
    DETAILS = 'DETAILS',
}

export const enum AccountType {
    WITHDRAWAL = 'WITHDRAW',
    DEPOSIT = 'DEPOSIT'
}
